import React from 'react';
import { cn } from 'utils';

type VideoCaptionProps = {
  text: string;
  color?: 'purple' | 'white';
  align?: 'left' | 'right';
  suppressWhenNoText?: boolean;
};

export function VideoCaption(
  props: VideoCaptionProps,
): React.ReactElement | null {
  const {
    text,
    color = 'white',
    align = 'left',
    suppressWhenNoText = false,
  } = props;

  if (!text && suppressWhenNoText) return null;

  return (
    <strong
      className={cn(
        'odin-absolute',
        'odin-z-10',
        'odin-border',
        'odin-border-2',
        'odin-font-normal',
        'odin-inset-1',
        'odin-px-2',
        'odin-py-1',
        'odin-rounded-md',
        'odin-text-left',
        'odin-uppercase',
        'odin-h-fit',
        color === 'purple'
          ? 'odin-border-purple-500 odin-text-purple-500'
          : 'odin-border-white odin-text-white',
        align === 'right'
          ? 'odin-right-1.5 odin-left-auto odin-top-1.5'
          : 'odin-left-1.5 odin-right-auto odin-top-1.5',
      )}
    >
      {text}
    </strong>
  );
}
